"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APColumn = exports.APRow = exports.getCrossAxisAlignment = exports.getMainAxisAlignment = void 0;
var react_1 = __importDefault(require("react"));
function getMainAxisAlignment(alignment) {
    switch (alignment) {
        case 'spaceAround': return 'space-around';
        case 'spaceBetween': return 'space-between';
        case 'spaceEvenly': return 'space-evenly';
        case 'center': return "center";
        case 'start': return "flex-start";
        case 'end': return "flex-end";
    }
}
exports.getMainAxisAlignment = getMainAxisAlignment;
function getCrossAxisAlignment(alignment) {
    switch (alignment) {
        case 'center': return "center";
        case 'start': return "flex-start";
        case 'end': return "flex-end";
        case 'stretch': return "stretch";
        case 'baseline': return "baseline";
    }
}
exports.getCrossAxisAlignment = getCrossAxisAlignment;
function getMainAxisSize(alignment) {
    switch (alignment) {
        case 'min': return "fit-content";
        case 'max': return "100%";
    }
}
function APRow(_a) {
    var _b = _a.mainAxisAlignment, mainAxisAlignment = _b === void 0 ? 'start' : _b, _c = _a.crossAxisAlignment, crossAxisAlignment = _c === void 0 ? 'center' : _c, _d = _a.mainAxisSize, mainAxisSize = _d === void 0 ? 'max' : _d, children = _a.children, style = _a.style, onClick = _a.onClick, gap = _a.gap;
    var mStyle = __assign({ display: "flex", flexDirection: "row", minWidth: 0, minHeight: 0, gap: gap, width: getMainAxisSize(mainAxisSize), cursor: onClick ? "pointer" : undefined, justifyContent: getMainAxisAlignment(mainAxisAlignment), alignItems: getCrossAxisAlignment(crossAxisAlignment) }, style);
    return (react_1.default.createElement(APFlex, { mStyle: mStyle, onClick: onClick }, children));
}
exports.APRow = APRow;
function APColumn(_a) {
    var _b = _a.mainAxisAlignment, mainAxisAlignment = _b === void 0 ? 'start' : _b, _c = _a.crossAxisAlignment, crossAxisAlignment = _c === void 0 ? 'center' : _c, _d = _a.mainAxisSize, mainAxisSize = _d === void 0 ? 'min' : _d, children = _a.children, style = _a.style, gap = _a.gap, onClick = _a.onClick;
    var mStyle = __assign({ display: "flex", flexDirection: "column", minWidth: 0, minHeight: 0, width: "100%", gap: gap, height: getMainAxisSize(mainAxisSize), cursor: onClick ? "pointer" : undefined, justifyContent: getMainAxisAlignment(mainAxisAlignment), alignItems: getCrossAxisAlignment(crossAxisAlignment) }, style);
    return (react_1.default.createElement(APFlex, { mStyle: mStyle, onClick: onClick }, children));
}
exports.APColumn = APColumn;
function APFlex(props) {
    return (react_1.default.createElement("div", { style: props.mStyle, onClick: props.onClick }, props.children));
}
